export const generatedAttribute = "generated";
export const randomColorValue = "random";
export const midColorValue = "mid";
export const touchEndEvent = "touchend";
export const mouseDownEvent = "mousedown";
export const mouseUpEvent = "mouseup";
export const mouseMoveEvent = "mousemove";
export const touchStartEvent = "touchstart";
export const touchMoveEvent = "touchmove";
export const mouseLeaveEvent = "mouseleave";
export const mouseOutEvent = "mouseout";
export const touchCancelEvent = "touchcancel";
export const resizeEvent = "resize";
export const visibilityChangeEvent = "visibilitychange";
export const noPolygonDataLoaded = "No polygon data loaded.";
export const noPolygonFound = "No polygon found, you need to specify SVG url in config.";
